import React from 'react';
import { useSelector } from 'react-redux';

import { useActionDispatcher } from '../../../hooks';
import { saveCurrentUserRequest } from '../../../store/modules/users/actions';
import { selectCurrentUser } from '../../../store/modules/users/selectors';
import UserForm from '../../users/UserForm';

type Props = {
  showOnlyAdminSettings?: boolean;
};

const CurrentUserEdit = ({ showOnlyAdminSettings = false }: Props) => {
  const user = useSelector(selectCurrentUser);

  const saveCurrentUser = useActionDispatcher(saveCurrentUserRequest);

  return (
    <UserForm
      currentMode
      record={user}
      onSubmit={saveCurrentUser}
      preventCancelChanges
      showOnlyAdminSettings={showOnlyAdminSettings}
      showPrivateFields
    />
  );
};

export default CurrentUserEdit;
